import axios from '../axios';

export const show = (lang) => {
  return axios.get(`/delivery-methods-additional-info?lang=${lang}`);
};

export const submit = (payload) => {
  return axios.post('/delivery-methods-additional-info', payload);
};
